import type { RuleHandler } from "../types";
import { setIncludes } from "../setIncludes";

const checkAllEventIdsMustMatch: RuleHandler = (context, requirement) => {
  if (
    !setIncludes(
      new Set(requirement.userDrivenAttributes?.eventIds),
      new Set(context.selection.eventIds),
      requirement.userDrivenAttributes?.allEventIdsMustMatch || false,
    )
  ) {
    return false;
  }

  return true;
};

export { checkAllEventIdsMustMatch };
